module.exports = __webpack_public_path__ + "static/media/exchange.f0b4be60.svg";